import { render, staticRenderFns } from "./PermissionDetail.vue?vue&type=template&id=0b1ac372&scoped=true&"
import script from "./PermissionDetail.vue?vue&type=script&lang=js&"
export * from "./PermissionDetail.vue?vue&type=script&lang=js&"
import style0 from "./PermissionDetail.vue?vue&type=style&index=0&id=0b1ac372&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1ac372",
  null
  
)

export default component.exports